import { z } from "zod";

export const tenantFormSchema = z.object({
  // Step 1: Basic Information
  name: z
    .string()
    .trim()
    .min(1, "Business name is required")
    .max(100, "Business name must be less than 100 characters"),
  slug: z
    .string()
    .trim()
    .min(1, "Slug is required")
    .max(50, "Slug must be less than 50 characters")
    .regex(/^[a-z0-9-]+$/, "Slug must contain only lowercase letters, numbers, and hyphens"),
  domain: z
    .string()
    .trim()
    .max(255, "Domain must be less than 255 characters")
    .optional()
    .or(z.literal("")),

  // Step 2: Contact & Billing
  billing_email: z
    .string()
    .trim()
    .min(1, "Billing email is required")
    .email("Invalid email format")
    .max(255, "Email must be less than 255 characters"),
  billing_via_agency: z.boolean().default(true),

  // Step 3: Plan & Limits
  plan_id: z.enum(["starter", "pro", "enterprise"], {
    required_error: "Please select a plan",
  }),
  max_users: z
    .number()
    .int()
    .positive("Must be a positive number")
    .optional()
    .nullable(),
  max_phone_numbers: z
    .number()
    .int()
    .positive("Must be a positive number")
    .optional()
    .nullable(),
  max_sms_per_day: z
    .number()
    .int()
    .positive("Must be a positive number")
    .optional()
    .nullable(),
});

export type TenantFormData = z.infer<typeof tenantFormSchema>;

// Step-specific schemas for partial validation
export const step1Schema = tenantFormSchema.pick({
  name: true,
  slug: true,
  domain: true,
});

export const step2Schema = tenantFormSchema.pick({
  billing_email: true,
  billing_via_agency: true,
});

export const step3Schema = tenantFormSchema.pick({
  plan_id: true,
  max_users: true,
  max_phone_numbers: true,
  max_sms_per_day: true,
});

export const defaultTenantFormValues: TenantFormData = {
  name: "",
  slug: "",
  domain: "",
  billing_email: "",
  billing_via_agency: true,
  plan_id: "starter",
  max_users: null,
  max_phone_numbers: null,
  max_sms_per_day: null,
};
